import {
  BasicButton,
  BasicInput,
  OptionSelect,
  SelectComponent,
} from "Common/Components";
import { getDefaultValueForSelect } from "helpers/functionsHelpers";
import { useInvAdjustmentForm } from "../hooks/useInvAdjustmentForm";
import { ArrowLeftRight, Save } from "lucide-react";

export const HeaderInvAdjustmentForm = () => {
  const {
    t,
    warehousesData,
    formik,
    payloadTransfer,
    existProductsInStore,
    setPayloadTransfer,
  } = useInvAdjustmentForm();

  const typeOptions = [
    { label: "ENTRADA", value: "ENTRADA" },
    { label: "SALIDA", value: "SALIDA" },
  ];

  return (
    <>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          formik.handleSubmit();
        }}
      >
        <div className="flex w-full items-center justify-end flex-wrap">
          <BasicButton onClick={() => {}} type="submit">
            <div className="flex flex-row justify-center items-center">
              <Save size={16} color="#fff" />
              <span className="ml-2 text-slate-50">
                {t("correlativeScreen.formAdminCorrelative.btnSave")}
              </span>
            </div>
          </BasicButton>
        </div>
        <div className="grid grid-cols-1 min-[768px]:grid-cols-12 gap-4">

          <div className=" col-span-1 w-full min-[768px]:col-span-6">
          <SelectComponent
  label={t(
    "InventoryAdjustment.headerTransferForm.selectLabelWarehouseOrigin"
  )}
  placeholder={t(
    "paymentSupplier.selectPlaceholderWareHouse"
  )}
  options={warehousesData} 
  id="providers"
  isMulti={false}
  value={getDefaultValueForSelect(
    warehousesData,
    formik.values.warehouseId
  )}
  onChange={(option: OptionSelect) => {
    if (option && option.value) {
      formik.setFieldValue("warehouseId", option.value);
      setPayloadTransfer({
        ...payloadTransfer,
        warehouseId: Number(option.value),
      });
    }
  }}
  isDisabled={existProductsInStore}
  isError={
    (formik.touched.warehouseId && Boolean(formik.errors.warehouseId)) ||
    false
  }
  errorMessage={formik.errors.warehouseId || ""}
/>
          </div>

          <div className="col-span-1 w-full min-[768px]:col-span-6">
          <SelectComponent
              label={t("InventoryAdjustment.headerTransferForm.type")}
              placeholder={t("InventoryAdjustment.headerTransferForm.selecttype")}
              options={typeOptions} 
              id="type" 
              isMulti={false}
              value={getDefaultValueForSelect(typeOptions, formik.values.type)} 
              onChange={(option: OptionSelect) => {
                if (option && option.value) {
                  formik.setFieldValue("type", option.value); 
                }
              }}
              isDisabled={existProductsInStore}
              isError={
                (formik.touched.type && Boolean(formik.errors.type)) ||
                false
              }
              errorMessage={formik.errors.type || ""}
            />
             </div>
          <div className=" col-span-1 w-full min-[768px]:col-span-12">
            <BasicInput
              id="observations"
              label={t(
                "transferBetweenWarehouse.headerTransferForm.labelObservations"
              )}
              placeholder={t(
                "transferBetweenWarehouse.headerTransferForm.placeholderObservations"
              )}
              onBlur={formik.handleBlur}
              onChange={({ target }) => {
                formik.setFieldValue("observations", target.value);
                setPayloadTransfer({
                  ...payloadTransfer,
                  observation: target.value,
                });
              }}
              type="text"
              value={formik.values.observations}
              isError={
                (formik.touched.observations &&
                  Boolean(formik.errors.observations)) ||
                false
              }
              errorMessage={formik.errors.observations || ""}
              className="w-full h-20"
            ></BasicInput>
          </div>
        </div>
      </form>
    </>
  );
};
